<div class="fixed top-0 right-0 p-6">
  <a href="https://www.facebook.com/deadlinealwaysexists">
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
  </a>
</div>

<div class="flex flex-col h-full justify-center items-center">
  <h1 class="text-sm text-dynamic text-center">
    เล่นเสร็จแล้วเป็นยังไง อย่าลืมมาแชร์เรื่องราวของคุณผ่าน<br>
    <b
      href="https://twitter.com/search?q=%23ห้องเล่นสีขาว"
      rel="noopener noreferrer"
      target="_blank"
      class="font-bold"
    >#ห้องเล่นสีขาว</b> กัน
  </h1>
  <div class="card-section overflow-x-auto w-screen">
    <div class='card-wrapper mx-auto'>
      <div class='card'><img src={card1} alt="card-1"></div>
      <div class='card'><img src={card2} alt="card-2"></div>
    </div>
  </div>
  <div class='fixed-width flex justify-center items-center space-x-2 text-dynamic'>
    <!-- prettier-ignore -->
    <svg class="w-5 h-5 md:w-8 md:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4">
      </path>
    </svg>
    <span class='text-xs'>คลิกขวา หรือ กดค้าง ที่รูปภาพเพื่อเซฟ</span>
  </div>

  <a 
    target="_blank"
    href={shared_url}
    class="fixed-width button is-primary mt-4 mx-auto w-full text-center rounded-lg"
  >
    แชร์เว็บนี้ให้เพื่อนเล่น
  </a>
  <div class="flex justify-center space-x-2 text-xs items-center mt-4">
    <div>Follow us</div>
    <a href="https://www.facebook.com/deadlinealwaysexists" target="_blank">
      <!-- prettier-ignore -->
      <svg class="w-6" viewBox="0 0 28 28">
        <path fill="currentColor" d="M13.9431 0C10.2452 0 6.6987 1.47267 4.08385 4.09404C1.46901 6.71541 0 10.2708 0 13.9779C0 17.6851 1.46901 21.2404 4.08385 23.8618C6.6987 26.4832 10.2452 27.9559 13.9431 27.9559C17.6411 27.9559 21.1876 26.4832 23.8024 23.8618C26.4173 21.2404 27.8863 17.6851 27.8863 13.9779C27.8863 10.2708 26.4173 6.71541 23.8024 4.09404C21.1876 1.47267 17.6411 0 13.9431 0ZM17.8399 8.50447H15.9979C15.3521 8.50447 15.22 8.77667 15.22 9.44614V11.072H17.8399L17.5904 13.9338H15.22V22.4677H11.8223V13.9706H10.0464V11.072H11.8223V8.79874C11.8223 6.65791 12.9671 5.53967 15.4916 5.53967H17.8399V8.50447Z"></path>
      </svg>
    </a>
    <a href="https://www.instagram.com/deadlinealways.exists" target="_blank">
      <!-- prettier-ignore -->
      <svg class="w-6" viewBox="0 0 28 28">
        <path fill="currentColor" d="M19.9498 9.47556C19.828 9.14174 19.6323 8.83992 19.3774 8.59275C19.1302 8.33805 18.8294 8.14199 18.4968 8.01892C18.0401 7.85248 17.559 7.76299 17.0732 7.75407C16.2659 7.71729 16.0237 7.70993 13.9836 7.70993C11.9435 7.70993 11.694 7.70993 10.8868 7.75407C10.4009 7.76299 9.91987 7.85248 9.46314 8.01892C9.13242 8.14559 8.83227 8.34117 8.58252 8.59275C8.32997 8.8418 8.13463 9.14307 8.01012 9.47556C7.8441 9.93343 7.75483 10.4157 7.74594 10.9028C7.70924 11.712 7.7019 11.9548 7.7019 14.0074C7.7019 16.0599 7.7019 16.2953 7.74594 17.1046C7.75483 17.5917 7.8441 18.0739 8.01012 18.5318C8.13463 18.8643 8.32997 19.1656 8.58252 19.4146C8.83227 19.6662 9.13242 19.8618 9.46314 19.9884C9.91987 20.1549 10.4009 20.2444 10.8868 20.2533C11.694 20.2901 11.9362 20.2974 13.9836 20.2974C16.0311 20.2974 16.2659 20.2974 17.0732 20.2533C17.559 20.2444 18.0401 20.1549 18.4968 19.9884C18.8294 19.8654 19.1302 19.6693 19.3774 19.4146C19.6323 19.1674 19.828 18.8656 19.9498 18.5318C20.1238 18.0761 20.2133 17.5925 20.214 17.1046C20.2507 16.2953 20.2581 16.0525 20.2581 14.0074C20.2581 11.9622 20.2581 11.712 20.214 10.9028C20.2133 10.4149 20.1238 9.93123 19.9498 9.47556ZM14.013 17.9432C13.2347 17.9432 12.474 17.7118 11.8269 17.2782C11.1799 16.8446 10.6758 16.2283 10.3783 15.5073C10.0808 14.7863 10.0033 13.9931 10.1557 13.228C10.3081 12.4629 10.6834 11.7603 11.2343 11.2091C11.7851 10.6579 12.4866 10.2829 13.2501 10.1316C14.0136 9.98031 14.8047 10.0594 15.5234 10.359C16.242 10.6586 16.8558 11.1652 17.2871 11.8146C17.7184 12.464 17.9479 13.2271 17.9464 14.0074C17.9445 15.0519 17.5292 16.053 16.7918 16.7909C16.0543 17.5288 15.0549 17.9432 14.013 17.9432ZM18.1005 10.8292C17.9174 10.8307 17.7379 10.7775 17.5848 10.6766C17.4318 10.5756 17.3122 10.4314 17.2411 10.2621C17.17 10.0929 17.1506 9.90626 17.1854 9.72597C17.2203 9.54568 17.3078 9.37982 17.4368 9.24945C17.5658 9.11907 17.7305 9.03005 17.9101 8.99369C18.0897 8.95732 18.2759 8.97524 18.4453 9.04518C18.6147 9.11512 18.7596 9.23392 18.8615 9.38651C18.9634 9.53911 19.0178 9.71861 19.0179 9.90226C19.0189 10.0262 18.995 10.149 18.9475 10.2634C18.9 10.3778 18.83 10.4814 18.7415 10.5679C18.6531 10.6545 18.5482 10.7223 18.433 10.7672C18.3178 10.8121 18.1947 10.8332 18.0712 10.8292H18.1005Z"></path>
        <path fill="currentColor" d="M14.013 11.4472C13.5079 11.4472 13.0142 11.5974 12.5942 11.8787C12.1742 12.16 11.8469 12.5599 11.6536 13.0277C11.4603 13.4955 11.4098 14.0102 11.5083 14.5069C11.6068 15.0035 11.8501 15.4597 12.2072 15.8177C12.5644 16.1758 13.0194 16.4196 13.5148 16.5184C14.0102 16.6172 14.5237 16.5665 14.9903 16.3727C15.457 16.1789 15.8558 15.8508 16.1364 15.4298C16.4171 15.0087 16.5668 14.5138 16.5668 14.0074C16.5668 13.3284 16.2978 12.6772 15.8188 12.1971C15.3399 11.717 14.6903 11.4472 14.013 11.4472Z"></path>
        <path fill="currentColor" d="M14.013 6.97024e-05C10.315 6.97024e-05 6.76852 1.47274 4.15367 4.09411C1.53883 6.71548 0.0698242 10.2708 0.0698242 13.978C0.0698242 17.691 1.54115 21.252 4.16012 23.8775C6.7791 26.503 10.3312 27.978 14.035 27.978C17.7388 27.978 21.2909 26.503 23.9098 23.8775C26.5288 21.252 28.0001 17.691 28.0001 13.978C28.0001 12.1387 27.638 10.3174 26.9346 8.61866C26.2311 6.9199 25.2001 5.37702 23.9007 4.07847C22.6013 2.77992 21.059 1.75124 19.3623 1.05138C17.6655 0.351525 15.8477 -0.0057387 14.013 6.97024e-05ZM21.5936 17.2076C21.5795 17.8433 21.4605 18.4722 21.2414 19.0689C21.0471 19.5817 20.7442 20.046 20.3534 20.4299C19.9721 20.8218 19.5082 21.1234 18.9958 21.3127C18.4021 21.5388 17.7741 21.6608 17.1392 21.6732C16.3246 21.71 16.0604 21.7174 13.9836 21.7174C11.9068 21.7174 11.6426 21.7174 10.8281 21.6732C10.1908 21.6599 9.56053 21.538 8.96408 21.3127C8.45427 21.1224 7.99304 20.8209 7.6138 20.4299C7.22303 20.046 6.92007 19.5817 6.72584 19.0689C6.50325 18.4732 6.38411 17.8437 6.37359 17.2076C6.3369 16.3837 6.32222 16.1262 6.32222 14.0442C6.32222 11.9622 6.32222 11.6974 6.37359 10.8734C6.38411 10.2374 6.50325 9.60786 6.72584 9.01216C6.91984 8.50688 7.21538 8.04696 7.5941 7.66097C7.97282 7.27498 8.42664 6.97114 8.92739 6.76833C9.52383 6.5431 10.1541 6.4212 10.7914 6.40785C11.6059 6.40785 11.8628 6.36371 13.9469 6.36371C16.031 6.36371 16.2879 6.36371 17.1025 6.40785C17.7374 6.42031 18.3654 6.54225 18.9591 6.76833C19.4687 6.96488 19.9317 7.26601 20.3184 7.65241C20.7051 8.03881 21.007 8.50196 21.2047 9.01216C21.4238 9.60884 21.5428 10.2378 21.5569 10.8734C21.5936 11.6974 21.601 11.9549 21.601 14.0442C21.601 16.1335 21.6303 16.3469 21.5936 17.2076Z"></path>
      </svg>
    </a>
  </div>
</div>

<script lang='ts'>
export let card1 = "/card/card_actionplay-01.png"
export let card2 = "/card/card_actionplay-05.png"

let shared_url = `https://www.facebook.com/dialog/share?
  app_id=467473238008797
  &display=popup
  &href=https%3A%2F%2Fwhiteplayroom.insidethesandbox.studio
  &hashtag=%23ห้องเล่นสีขาว`.replace(/\s/g, '')

</script>

<style lang='scss'>
.fixed-width {
  width: min(300px, 100%)
}
.card-section {
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  padding-top: 1rem;
  padding-bottom: 1rem;
  filter: drop-shadow(3px 4px 6px #22222299);
}

.card-wrapper {
  --size: 350px;
  display: flex;
  width: calc(var(--size) * 2);
  // padding-left: 2rem;
  // padding-right: 2rem;
  
  .card img {
    padding: 0.5rem;
    height: var(--size) !important;
    padding-left: 1rem;

    border-radius: 57px;
    overflow: hidden;
    width: calc(var(--size) + 1.5rem) !important;
    // border: solid red 1px;
    object-fit: cover;
    
  }
}
</style>